import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import type { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RedoPlatformAuthRpcClientContext } from "./platform/redo-platform-rpc-client-provider";
import { TeamContext } from "./team";
import { UserContext } from "./user";

export interface TeamFeatureFlagState {
  readonly pending: boolean;
  readonly enabled: boolean;
}

export function useTeamFeatureFlag(
  flagKey: FeatureFlagKey,
): TeamFeatureFlagState {
  const user = useContext(UserContext);
  const team = useRequiredContext(TeamContext);
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );

  const isRedoEmail = isRedoEmailAddress(user?.email);

  const query = useQuery({
    queryKey: ["featureFlag", flagKey, String(team._id)],
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({ flagKey });
      return response.enabled;
    },
    enabled: !isRedoEmail,
    staleTime: Infinity,
  });

  return {
    pending: !isRedoEmail && query.isPending,
    enabled: isRedoEmail || (query.data ?? false),
  };
}
